import * as React from "react";

function SvgClearFilter(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 34 34" fill="none" {...props}>
      <path
        d="M32.4044 0H1.59536C0.176786 0 -0.53263 1.71966 0.468377 2.72073L12.75 15.0039V22.6519C12.758 17.1818 17.1948 12.75 22.6667 12.75C22.9376 12.75 23.206 12.7609 23.4714 12.7822L33.5313 2.72073C34.5344 1.71766 33.82 0 32.4044 0Z"
        fill="white"
      />
      <path
        d="M18.3076 31.5764C15.0203 29.9651 12.7557 26.588 12.75 22.6815V32.4049C12.75 33.7007 14.2096 34.4442 15.2577 33.7106L18.3076 31.5764Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.6667 34C28.9259 34 34 28.9259 34 22.6667C34 16.4074 28.9259 11.3333 22.6667 11.3333C16.4074 11.3333 11.3333 16.4074 11.3333 22.6667C11.3333 28.9259 16.4074 34 22.6667 34ZM22.6667 32.5833C28.1435 32.5833 32.5833 28.1435 32.5833 22.6667C32.5833 17.1898 28.1435 12.75 22.6667 12.75C17.1898 12.75 12.75 17.1898 12.75 22.6667C12.75 28.1435 17.1898 32.5833 22.6667 32.5833Z"
        fill="white"
      />
      <path
        d="M22.6667 24.3667L26.6333 28.3333L28.3333 26.6333L24.3667 22.6667L28.3333 18.7L26.6333 17L22.6667 20.9667L18.7 17L17 18.7L20.9667 22.6667L17 26.6333L18.7 28.3333L22.6667 24.3667Z"
        fill="white"
      />
    </svg>
  );
}

export default SvgClearFilter;
